export default {
  title: 'Suosituimmat tuotteet',
  columns: {
    name: 'Nimi',
    quantity: 'Määrä',
    amount: 'Summa',
  },
};
